// axiosConfig.js
import axios from "axios";
import { useAssetReportStore } from "../zustand/assetReport.store";

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});
AxiosInstance.interceptors.request.use(
  (config) => {
    const token = useAssetReportStore.getState().userToken;
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// axiosRetry(AxiosInstance, {
//   retries: 3, // Number of retry attempts
//   retryDelay: (retryCount) => {
//     return retryCount * 1000; // Exponential backoff (1s, 2s, 3s)
//   },
//   retryCondition: (error) => {
//     // Retry on network errors or 5xx server errors
//     // Retry on network errors or 5xx server errors
//     return (
//       (error.response?.status ?? 0) >= 500 || error.code === "ECONNABORTED"
//     );
//   },
// });

export default AxiosInstance;
